import { render, staticRenderFns } from "./DocumentSettings.vue?vue&type=template&id=2675872c&scoped=true"
import script from "./DocumentSettings.vue?vue&type=script&lang=js"
export * from "./DocumentSettings.vue?vue&type=script&lang=js"
import style0 from "./DocumentSettings.vue?vue&type=style&index=0&id=2675872c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675872c",
  null
  
)

export default component.exports